// extracted by mini-css-extract-plugin
module.exports = {"root":"CountDownCell_root__3a3eA","status-icon":"CountDownCell_status-icon__26Wtr"};